module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Final_Step1-4.e3b63478.mp4";